// @flow weak

import { routerReducer } from "react-router-redux";
import { combineReducers } from "redux";
import user from "./user";
import authentication from "./authentication";
import views from "./views";
import sideMenu from "./sideMenu";
import categoryReducer from "./categoryReducer";
import categoryDetailReducer from "./categoryDetailReducer";
import countryCityReducers from "./countryCityReducers";
import subAdminReducer from "./subAdminReducer";
import siteReducer from "./siteReducer";
import merchantReducer from "./merchantReducer";
import contractReducer from "./contractReducer";
import dealReducer from "./dealReducer";
import affiliateReducer from "./affiliateReducer";
import promoReducer from "./promoReducer";
import alertsReducer from "./alertsReducer";
import frontReducer from "./frontReducer";
import voucherReducer from "./voucherReducer";
import paymentSettingReducer from "./paymentSettingReducer";


import salesPersonReducer from "./salesPersonReducer";
import reportReducer from "./reportReducer";
import emailReducer from "./emailReducer";
import termsPolicyAndContactReducer from "./termsPolicyAndContactReducer";
import reviewReducer from "./reviewReducer";
import faqReducer from "./faqReducer";
import questionReducer from "./questionReducer";
import designCenterReducer from "./designCenterReducer";
import emailManagerReducer from './emailManagerReducer';
import postupReducer from './postupReducer';
import pageTemplateReducer from './pageTemplateReducer';
import payoutReducer from './payoutReducer';
import charityReducer from './charityReducer';
import citypasswordReducer from './citypasswordReducer';
import announcementsReducer from './announcementsReducer';

export const mainReducers = {
  user,
  authentication,
  sideMenu,
  views,
  categoryReducer,
  categoryDetailReducer,
  countryCityReducers,
  subAdminReducer,
  siteReducer,
  merchantReducer,
  contractReducer,
  dealReducer,
  affiliateReducer,
  promoReducer,
  alertsReducer,
  frontReducer,
  voucherReducer,
  paymentSettingReducer,
  salesPersonReducer,
  reportReducer,
  emailReducer,
  termsPolicyAndContactReducer,
  reviewReducer,
  faqReducer,
  questionReducer,
  designCenterReducer,
  emailManagerReducer,
  postupReducer,
  pageTemplateReducer,
  payoutReducer,
  charityReducer,
  citypasswordReducer,
  announcementsReducer
};

export default combineReducers({
  ...mainReducers,
  routing: routerReducer
});



// WEBPACK FOOTER //
// ./src/app/redux/reducers/mainReducers.js